import getTagValue from "./get-tag-value";

export const sortShopFront = (endpoints) => {
    const sorted = [];
    const pinned = endpoints.filter((e => {
        if (!getTagValue(e.tags, 'pinIndex', ':')) {
            sorted.push(e);
            return false;
        } else {
            return true;
        }
    }));
    sorted.sort((a, b) => getTagValue(a.tags, 'rank', ':', Infinity) - getTagValue(b.tags, 'rank', ':', Infinity));
    pinned.sort((a, b) => new Date(getTagValue(a.tags, 'pinTime', ':')) - new Date(getTagValue(b.tags, 'pinTime', ':')));
    pinned.forEach(element => {
        const pinIndex = parseInt(getTagValue(element.tags, 'pinIndex', ':'));
        sorted.splice(pinIndex, 0, element);
    });
    return sorted;
};